import { assert } from '../guards'

import type { PaletteType } from './constants'
import { gridToPalette, palette } from './constants'

export const getPalette = (paletteType: PaletteType) => palette[paletteType]

export const getPaletteByGridType = (gridTypeId: number) => {
  const palette = gridToPalette[gridTypeId]

  assert(palette !== undefined, `Неизвестный тип карты: ${gridTypeId}`)

  return palette
}

export type { PaletteType }
export { getRandomColor } from './color'
export type { ColorType } from './color'
export { sortPalettes } from './sort'
